/**
 * @author Angel Labrada Masso
 * @since v0.0.1
 * @date 05/08/2022
 */
import React, {memo} from 'react';
import PropTypes from 'prop-types';
import {Select} from 'antd';
import {useTranslation} from 'react-i18next';

const Option = Select;

const SelectPeriod = ({value, onChange, ...props}) => {
  const {t} = useTranslation('registers');

  return (
    <div className='flex justify-start items-center w-full min-w-48'>
      <Select
        placeholder={t('form.placeholderTemplatePeriod')}
        optionFilterProp="children"
        onChange={onChange}
        defaultValue={value}
        value={value}
        className="custom-select w-full"
        {...props}
      >
        <Option value="daily">{t('daily')}</Option>
        <Option value="weekly">{t('weekly')}</Option>
        <Option value="monthly">{t('monthly')}</Option>
        <Option value="bimonthly">{t('bimonthly')}</Option>
        <Option value="quarterly">{t('quarterly')}</Option>
        <Option value="semester">{t('semester')}</Option>
        <Option value="yearly">{t('yearly')}</Option>
      </Select>
    </div>
  );
};

SelectPeriod.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
};

SelectPeriod.defaultProps = {
  value: null
};

export default memo(SelectPeriod);

const SelectPeriodView = ({value}) => {
  const {t} = useTranslation('registers');

  return (
    <div>
      {t(value)}
    </div>
  );
};

SelectPeriodView.propTypes = {
  value: PropTypes.string
};

/**
 * cellRender
 * */
/**
 * This is not a component,
 * it is a function to render the Date component in a table cell
 * @param {string} value this is value of de column
 * */
export const renderPeriodCell = (value) => {
  return (
    <SelectPeriodView value={value}/>
  );
};
